const { getThresholds, getThresholdRelativeToMOS } = require('../../../forecast/tools/read/psm-thresholds')
const { DAYS_PER_MONTH } = require('../../constants')

function buildCalculationModalData ({
  soh,
  amc: amcInput,
  programId,
  budgetAllocatedQty,
  minLevel,
  reorderPoint,
  maxLevel,
  leadTimeDays
}) {
  const thresholds = getThresholds(programId)
  const { min, reOrder, max } = thresholds

  const hasForecastLevels = maxLevel != null
  const leadTimeMonths = hasForecastLevels
    ? (leadTimeDays != null ? leadTimeDays / DAYS_PER_MONTH : reOrder.months - min.months)
    : reOrder.months - min.months

  const amc = amcInput != null ? amcInput : 0
  const currentSoh = soh != null ? soh : 0

  // Current stock in months (raw for logic, rounded for display)
  let rawStockMonths
  if (amc > 0) {
    rawStockMonths = currentSoh / amc
  } else {
    rawStockMonths = currentSoh > 0 ? 99 : 0
  }
  const currentStockMonths = rawStockMonths === 99
    ? 99
    : parseFloat(rawStockMonths.toFixed(1))

  // Threshold for current stock box
  let threshold
  if (hasForecastLevels) {
    if (currentSoh <= (minLevel || 0)) threshold = 'critical'
    else if (currentSoh <= (reorderPoint || 0)) threshold = 'ok'
    else if (currentSoh <= maxLevel) threshold = 'good'
    else threshold = 'extra'
  } else {
    threshold = getThresholdRelativeToMOS(thresholds, rawStockMonths)
  }

  // Zero soh + zero consumed = no basis (amc arrives as 0); zero the whole calculation
  // so the target rows and "you need" can't contradict each other.
  const noData = amc === 0 && currentSoh === 0
  const leadTimeConsumption = Math.round(amc * leadTimeMonths)

  // Order-up-to level (forecast maxLevel already includes the lead-time pipeline; the
  // legacy path adds it onto max.months). quantityNeeded is unchanged — it still drives
  // the same suggested quantity as the order algorithm.
  const effectiveTarget = noData
    ? 0
    : hasForecastLevels ? maxLevel : Math.round(amc * (max.months + leadTimeMonths))
  const suggestedQuantity = effectiveTarget - currentSoh

  // Displayed target excludes the in-transit pipeline so the breakdown reconciles:
  // target − on hand + lead-time consumption = you need.
  const targetStockLevel = noData ? 0 : (effectiveTarget - leadTimeConsumption)
  const targetMonths = noData ? 0 : parseFloat((amc > 0 ? targetStockLevel / amc : max.months).toFixed(1))

  // Budget coverage (optional)
  const hasBudgetData = budgetAllocatedQty != null
  let budgetCovers = null
  let budgetResultMonths = null
  if (hasBudgetData) {
    budgetCovers = budgetAllocatedQty
    if (amc > 0) {
      budgetResultMonths = parseFloat(((currentSoh + budgetAllocatedQty) / amc).toFixed(1))
    }
  }

  return {
    currentStockLevel: currentSoh,
    currentStockMonths,
    threshold,
    targetMonths,
    targetStockLevel,
    amc,
    calculation: {
      targetWithBuffer: effectiveTarget,
      currentStockOnHand: currentSoh,
      leadTimeConsumption,
      quantityNeeded: suggestedQuantity,
      budgetCovers,
      budgetResultMonths
    }
  }
}

exports.buildCalculationModalData = buildCalculationModalData
